import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/CertificateCourses.css';

const certificateData = [
  {
    title: 'Certificate Course in Computer Science',
    description: 'Skill development program provided by Mahajyoti to enhance employability.',
    subCourses: [
      {
        name: 'Mahaskill Employability Skills Certificate Course',
        syllabusLink: 'https://example.com/mahaskill-syllabus.pdf',
      },
    ],
  },
  {
    title: 'Physics and Electronics',
    description: 'Hands-on technical programs for electronics fundamentals and repair skills.',
    subCourses: [
      { name: 'Instrument Repairing and Testing', syllabusLink: 'https://example.com/instrument-syllabus.pdf' },
      { name: 'PCB Designing', syllabusLink: 'https://example.com/pcb-syllabus.pdf' },
    ],
  },
  {
    title: 'Marathi',
    subCourses: [
      { name: 'Writing Skill in Marathi' },
    ],
  },
  {
    title: 'Hindi',
    subCourses: [
      { name: 'Hindi Translation' },
      { name: 'Advertisement' },
    ],
  },
  {
    title: 'English',
    description: 'Focused on building core and advanced communication skills.',
    subCourses: [
      { name: 'Basic Skills in English Language' },
      { name: 'Advance Communication Skills' },
      { name: 'Basic Skills in English Language' },
    ],
  },
  {
    title: 'Economics',
    subCourses: [
      { name: 'Banking Literacy' },
      { name: 'Digital Banking' },
    ],
  },
  {
    title: 'Political Science',
    subCourses: [
      { name: 'Indian Constitution Literacy' },
    ],
  },
  {
    title: 'Geography',
    subCourses: [
      { name: 'Surveying' },
      { name: 'Travel and Tourism Management' },
      { name: 'Organic Farming' },
    ],
  },
  {
    title: 'Chemistry',
    subCourses: [
      { name: 'Water Analysis' },
    ],
  },
  {
    title: 'Botany',
    subCourses: [
      { name: 'Nursery Management and Horticultural Practices' },
    ],
  },
];

const CertificateCourses = () => {
  const [fadeIn, setFadeIn] = useState(false);
  useEffect(() => {
    setTimeout(() => setFadeIn(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`cert-container ${fadeIn ? 'fade-in' : ''}`}>
        <section className="cert-header">
          <h4>SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</h4>
          <h2>Certificate Courses</h2>
          <p>Explore our wide range of certificate programs across various disciplines designed to enhance practical and academic skills.</p>
        </section>

        <section className="cert-list">
          {certificateData.map((dept, idx) => (
            <div className="cert-card" key={idx}>
              <h3>{dept.title}</h3>
              {dept.description && <p className="dept-description">{dept.description}</p>}
              <ul>
                {dept.subCourses.map((course, subIdx) => (
                  <li key={subIdx}>
                    {course.name}
                    {course.syllabusLink && (
                      <a
                        href={course.syllabusLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="syllabus-link"
                      >
                        (Syllabus)
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default CertificateCourses;
